import React from 'react';
import { officialEmotes } from './official-emotes';
import { isValidFileSrc } from '../../components/utils/xss';
import { cleanLinkSrc } from '../../components/utils/browser';
import s from './viewer.scss';
const Viewer = (props)=>{
    const HTMLAttributes = props.node.attrs;
    if (HTMLAttributes['data-type'] === 'official') {
        var _officialEmotes_HTMLAttributes_dataemote;
        const emote = (_officialEmotes_HTMLAttributes_dataemote = officialEmotes[HTMLAttributes['data-emote']]) !== null && _officialEmotes_HTMLAttributes_dataemote !== void 0 ? _officialEmotes_HTMLAttributes_dataemote : officialEmotes[':deviantart:'];
        return /*#__PURE__*/ React.createElement("img", {
            loading: "lazy",
            src: `https://e.deviantart.net/emoticons${emote.src}`,
            alt: emote.name,
            width: emote.width,
            height: emote.height,
            "data-emote": HTMLAttributes['data-emote'],
            className: s['emote'],
            "data-type": 'official'
        });
    }
    if (HTMLAttributes['data-type'] === 'community') {
        return /*#__PURE__*/ React.createElement("a", {
            "data-url": cleanLinkSrc(HTMLAttributes.url),
            "data-src": cleanLinkSrc(isValidFileSrc(HTMLAttributes.src) ? HTMLAttributes.src : ''),
            "data-emote": '-community-',
            "data-type": 'community',
            "data-width": HTMLAttributes.width,
            "data-height": HTMLAttributes.height,
            "data-title": HTMLAttributes.title,
            href: cleanLinkSrc(HTMLAttributes.url)
        }, /*#__PURE__*/ React.createElement("img", {
            loading: "lazy",
            src: isValidFileSrc(HTMLAttributes.src) ? HTMLAttributes.src : '',
            width: Math.min(parseInt(HTMLAttributes.width), 500),
            height: Math.min(parseInt(HTMLAttributes.height), 500),
            alt: HTMLAttributes.title,
            "data-url": cleanLinkSrc(HTMLAttributes.url),
            className: s['emote'],
            "data-emote": '-community-',
            "data-type": 'community'
        }));
    }
    if (HTMLAttributes['data-type'] === 'user') {
        return /*#__PURE__*/ React.createElement("a", {
            "data-url": cleanLinkSrc(HTMLAttributes.url),
            "data-src": cleanLinkSrc(isValidFileSrc(HTMLAttributes.src) ? HTMLAttributes.src : ''),
            "data-emote": '-user-',
            "data-type": 'user',
            "data-width": HTMLAttributes.width,
            "data-height": HTMLAttributes.height,
            "data-title": HTMLAttributes.title,
            href: cleanLinkSrc(HTMLAttributes.url)
        }, /*#__PURE__*/ React.createElement("img", {
            loading: "lazy",
            src: /^https:\/\/a\.deviantart\.net\/avatars/.test(HTMLAttributes.src) ? HTMLAttributes.src : '',
            width: Math.min(parseInt(HTMLAttributes.width), 500),
            height: Math.min(parseInt(HTMLAttributes.height), 500),
            alt: HTMLAttributes.title,
            "data-url": cleanLinkSrc(HTMLAttributes.url),
            className: s['emote'],
            "data-emote": '-user-',
            "data-type": 'user'
        }));
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null);
};
export default Viewer;

//# sourceMappingURL=viewer.js.map